// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"a6dd2695","257":"07641987","800":"c6376e3f","949":"3844fe65"}[chunkId] + ".chunk.js";
};